import { render, staticRenderFns } from "./ChipRounded.vue?vue&type=template&id=a158a220&scoped=true&"
import script from "./ChipRounded.vue?vue&type=script&lang=js&"
export * from "./ChipRounded.vue?vue&type=script&lang=js&"
import style0 from "./ChipRounded.vue?vue&type=style&index=0&id=a158a220&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a158a220",
  null
  
)

export default component.exports